import React from 'react';
import './modalBox.css';

const PopupWidget = props => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary Popup_Button"
        id="Login_to_view_button"
        data-toggle="modal"
        data-target="#GeneralModalCenter"
        style={{ display: 'none' }}
      >
        {props.buttonLabel}
      </button>

      <div
        className="modal"
        id="GeneralModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="GeneralModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content modal-lg">
            <div className="modal-header custom_header_modal">
              <button
                style={{ zIndex: 1000 }}
                type="button"
                id="GeneralModalCenterClose"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body General_Popup_Modal_Body">
              {props.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopupWidget;
